import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=90b59d50&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQ.vue?vue&type=style&index=0&id=90b59d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b59d50",
  null
  
)

export default component.exports